export const tr = {
    'internal-network': 'Dahili ağ',
    'invalid-url': 'Hatalı URL',
    'is-mobile': 'Mobil cihaz (isMobile)',
    'is-tablet': 'Tablet (isTablet)',
    'is-touch': 'Dokunmatik cihaz (isTouch)',
    'is-virused': 'Algılanan virüs işareti',
    'is-yandex-plus': 'Yandex Plus',
    no: 'Hayır',
    'not-selected': 'Seçilmedi',
    yes: 'Evet'
};
